import 'reflect-metadata';
import {
  Expose,
  Type,
  plainToInstance,
  instanceToPlain,
} from 'class-transformer';
import { OrderStatus } from './enums/OrderStatus';

export class OrderSummary {
  id: number;

  status: OrderStatus;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  total: string;

  @Expose({ name: 'total_bv' })
  totalPv: string;

  @Expose({ name: 'package' })
  packages: string;

  constructor(
    id: number,
    status: OrderStatus,
    dateCreated: Date,
    total: string,
    totalPv: string,
    packages: string
  ) {
    this.id = id;
    this.status = status;
    this.dateCreated = dateCreated;
    this.total = total;
    this.totalPv = totalPv;
    this.packages = packages;
  }

  static fromJson(json: Record<string, any>): OrderSummary {
    return plainToInstance(OrderSummary, json, { enableCircularCheck: true });
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
